<template>
    <base-modal
      :ref="modal.key"
      :show="open"
      :title="modalTitle"
      @on-confirm="sendPassword"
      @on-cancel="hide()"
      :okText="$t('Login')"
      :closeText="$t('Close')"
    >
        <v-text-field
          v-bind:label="$t('Password')"
          v-model="password"
          maxlength="100"
          :error-messages="passwordErrors"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
          @input="$v.password.$touch()"
          @blur="$v.password.$touch()"
          @keydown.enter.prevent="sendPassword"
        ></v-text-field>
    </base-modal>
  </template>
<script>
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

export default {
    name: 'ConfirmPasswordModal',
    data() {
        return {
            modal: {
                title: this.$t('Site.Delegations.EnterPassword'),
                key: 'confirmPasswordModal',
            },
            open: false,
            password: '',
            showPassword: false
        };
    },
    mixins: [validationMixin],
    validations: {
        password: { required }
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        modalTitle() {
            return this.modal.title;
        },
        passwordErrors() {
            const errors = [];
            if (!this.$v.password.$dirty) return errors;
            !this.$v.password.required && errors.push(this.$t('RequiredField'));
            return errors;
        }
    },
    methods: {
        sendPassword() {
            this.$v.$touch();
            this.modalInstance.progress(true);
            if (this.$v.$invalid) {
                return;
            }
            this.$emit('password-confirmed', this.password);
        },
        new() {
            this.password = '';
            this.$v.$reset();
            this.show();
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>